import { createFileRoute } from '@tanstack/react-router';
import { CalendarPage } from '@pages/calendar';

/** Route für die Kalender-Seite (/kalender). */
export const Route = createFileRoute('/kalender')({ component: CalendarPage });
